<template>
  <div class="section_wrap">
    <div class="head">
      <!-- <div class="head-left"></div> -->
      <div class="head-center">
        <div class="title">
          <div class="title-text">推荐活动</div>
          <div class="title-icon" @click="toMoreData()">
            <el-image class="elimage" :src="moreicon" />
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="showcase">
        <template v-if="listData.length">
          <div class="goods-list">
            <div class="goods-item" v-for="(item, index) in listData" :key="index">
              <div class="goods-item-img">
                <template>
                  <div class="goods-img" @click="toDetail(item)">
                    <el-image class="image" :src="item.cover" @error="handleError" />
                  </div>
                </template>
              </div>
              <div class="goods-item-info">
                <div class="title">
                  <span class="txt ellipsis">{{ item.title }}</span>
                  <span class="category_name ellipsis">{{ item.category_name }}</span>
                </div>
                <div class="time ellipsis">
                  <span class="tit">活动时间：</span>
                  <span class="txt">{{ item.start_time | dateFormat }} / {{ item.end_time | dateFormat }}</span>
                </div>
                <div class="tags ellipsis">
                  <el-tag class="tag" size="small" v-for="(ele, inx) in item.tag_list" :key="inx">{{ ele.name
                  }}</el-tag>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty :image-size="110" class="el-empty--cont"></el-empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList } from "@/api/activity"
import dayjs from "dayjs"
export default {
  name: "homeActivity",
  components: {},
  filters: {
    dateFormat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY.MM.DD HH:mm:ss")
    },
  },
  data() {
    return {
      queryParams: {
        keyword: "",
        per_page: 10,
        page: 1,
      },
      listData: [],
      moreicon: require("@/assets/home/more.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  mounted() {
    this.getList()
  },
  methods: {
    handleError(e) {
      e.target.src = this.goodsimage
    },
    // 获取列表数据
    getList() {
      getActivityList(this.queryParams).then((res) => {
        if (res.code === 0) {
          this.listData = res.data?.data ?? []
          // let resData = res.data.data
          // this.listData = [...resData, ...resData]
        }
      }).catch(() => { })
    },
    // 加载更多数据
    toMoreData() {
      window.localStorage.setItem("menuId", 1)
      this.$store.dispatch("setmenuid", 1)
      this.$router.push({
        path: "/home/activity/mainpage",
      })
    },

    toDetail(item) {
      if (item.introduce_type && Number(item.introduce_type) === 1) {
        window.open(item.introduce_link, "_blank")
      } else {
        window.localStorage.setItem("menuId", 1)
        this.$store.dispatch("setmenuid", 1)
        this.$router.push({
          path: "/home/activity/detail",
          query: {
            id: item.id || "",
          },
        })
      }
    },
  },
};
</script>
<style scoped lang="scss">
.section_wrap {
  width: 100%;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;

    .head-left {
      width: 64px;
    }

    .head-center {

      // flex: 1;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;

        // padding: 0 10px;
        .title-icon {
          width: 32px;
          min-width: 32px;
          height: 32px;
          margin-left: 10px;

          .elimage {
            width: 100%;
            height: 100%;
          }
        }

        .title-text {
          color: #000;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }

    .head-right {
      .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        margin-left: 15px;

        .elimage {
          width: 38px;
          height: 38px;
        }
      }
    }
  }

  .body {
    .showcase {

      // margin: 0 -10px;
      .goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .goods-item {
          width: calc((100% - 80px) / 5);
          height: 360px;
          background-color: #fff;
          // box-shadow: 0px 0px 29px 0px rgb(0 80 179 / 8%);
          border-radius: 5px;
          overflow: hidden;
          flex-shrink: 1;
          // cursor: pointer;
          margin: 30px 0px 0px 20px;

          // &:hover {
          //   border: 1px solid rgb(9, 235, 178);
          // }
          .goods-item-img {
            position: relative;
            height: calc(100% - 124px);
            overflow: hidden;
            cursor: pointer;

            .goods-img {
              width: 100%;
              height: 100%;
              background: aliceblue;

              .image {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
                transition: transform 0.3s;
              }

              .image:hover,
              .image:focus,
              .image:active {
                transform: scale(1.1);
              }
            }

            .default-img {
              width: 100%;
              height: 100%;
              text-align: center;
              background: aliceblue;

              .image {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
                transition: transform 0.3s;
              }

              .image:hover,
              .image:focus,
              .image:active {
                transform: scale(1.1);
              }
            }
          }

          .goods-item-info {
            height: 124px;
            padding: 15px 10px;
            background: #ffffff;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .txt {
                display: inline-block;
                flex: 1;
                color: #000;
                font-size: 16px;
                font-weight: 500;
                padding-right: 8px;
              }

              .category_name {
                display: inline-block;
                width: 80px;
                padding: 6px 10px;
                border-radius: 5px;
                background-color: #005cbb;
                color: #fff;
                font-size: 12px;
                box-sizing: border-box;
                text-align: center;
              }
            }

            .time {
              height: 20px;
              line-height: 20px;
            }

            .tit,
            .txt {
              color: #999;
              font-size: 12px;
              font-weight: 400;
              border-radius: 12px;
            }

            .tags {
              .tag {
                height: 24px;
                border-radius: 24px;
                margin-right: 3px;
              }
            }
          }
        }

        .goods-item:nth-child(5n + 1) {
          margin-left: 0px;
        }

        .goods-item:nth-child(n + 6) {
          margin-top: 20px;
        }
      }
    }
  }
}

.el-empty--cont {
  padding: 0px;
  min-height: 200px;
}

@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-text {
            font-size: 20px;
          }

          .title-icon {
            width: 24px;
            min-width: 24px;
            height: 24px;
          }
        }
      }
    }

    .body {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 10px) / 2);
            height: auto;
            margin: 10px 0 0 10px;

            .goods-item-img {
              height: 140px;

              .goods-img {
                height: 100%;
              }

              .default-img {
                height: 100%;
              }
            }

            .goods-item-info {
              height: auto;
              padding: 10px;

              .title {
                .txt {
                  font-size: 14px;
                }

                .category_name {
                  width: auto;
                  padding: 4px 6px;
                  font-size: 10px;
                }
              }

              .time {

                .tit,
                .txt {
                  font-size: 11px;
                }
              }
            }
          }

          .goods-item:nth-child(2n + 1) {
            margin-left: 0;
          }

          .goods-item:nth-child(n + 6) {
            margin-top: 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .section_wrap {
    .body {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 60px) / 4);
            height: 320px;
          }

          .goods-item:nth-child(4n + 1) {
            margin-left: 0;
          }

          .goods-item:nth-child(5n + 1) {
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>